import { components as ReactSelectComponents } from 'react-select';

import { Control } from './Control.js';
import { Group } from './Group.js';
import { GroupHeading } from './GroupHeading.js';
import { Menu } from './Menu.js';
import { MenuList } from './MenuList.js';
import { MultiValue } from './MultiValue.js';
import { NoOptionsMessage } from './NoOptionsMessage.js';
import { Option } from './Option.js';
import { Placeholder } from './Placeholder.js';
import { ValueContainer } from './ValueContainer.js';

/**
 * Map of override components for the react select. These are the components that are actually rendered
 * with the react-select component.
 */
export const components: Partial<typeof ReactSelectComponents> = {
  Control,
  ClearIndicator: ReactSelectComponents.ClearIndicator,
  DropdownIndicator: ReactSelectComponents.DropdownIndicator,
  DownChevron: ReactSelectComponents.DownChevron,
  CrossIcon: ReactSelectComponents.CrossIcon,
  // Needs a cast here, because in the MultiValue we extend the generic for our _BaseOption and _BaseGroup data types
  // which in turn no longer overlaps with the default generic here.
  Group: Group as (typeof ReactSelectComponents)['Group'],
  // Needs a cast here, because in the MultiValue we extend the generic for our _BaseOption and _BaseGroup data types
  // which in turn no longer overlaps with the default generic here.
  GroupHeading: GroupHeading as (typeof ReactSelectComponents)['GroupHeading'],
  IndicatorsContainer: ReactSelectComponents.IndicatorsContainer,
  IndicatorSeparator: ReactSelectComponents.IndicatorSeparator,
  Input: ReactSelectComponents.Input,
  LoadingIndicator: ReactSelectComponents.LoadingIndicator,
  Menu,
  // Needs a cast here, because in the MultiValue we extend the generic for our _BaseOption and _BaseGroup data types
  // which in turn no longer overlaps with the default generic here.
  MenuList: MenuList as (typeof ReactSelectComponents)['MenuList'],
  MenuPortal: ReactSelectComponents.MenuPortal,
  LoadingMessage: ReactSelectComponents.LoadingMessage,
  // Needs a cast here, because the types for NoOptionsMessage do expect a defaultProps member to be there
  // coming in from their propTypes
  // https://github.com/JedWatson/react-select/blob/a465818786afd4857c9155bef1e9aa2fe3356097/packages/react-select/src/components/Menu.tsx#L517-L519C3
  NoOptionsMessage:
    NoOptionsMessage as (typeof ReactSelectComponents)['NoOptionsMessage'],
  // Needs a cast here, because in the MultiValue we extend the generic for our _BaseOption and _BaseGroup data types
  // which in turn no longer overlaps with the default generic here.
  MultiValue: MultiValue as (typeof ReactSelectComponents)['MultiValue'],
  MultiValueContainer: ReactSelectComponents.MultiValueContainer,
  MultiValueLabel: ReactSelectComponents.MultiValueLabel,
  MultiValueRemove: ReactSelectComponents.MultiValueRemove,
  // Needs a cast here, because in the Option we extend the generic for our _BaseOption and _BaseGroup data types
  // which in turn no longer overlaps with the default generic here.
  Option: Option as (typeof ReactSelectComponents)['Option'],
  Placeholder,
  SelectContainer: ReactSelectComponents.SelectContainer,
  SingleValue: ReactSelectComponents.SingleValue,
  ValueContainer,
};
